import { PopupRequest } from '@azure/msal-browser';

// Application API Login Request Configuration
// Note: scopes will be set dynamically from runtime config
export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile',
    'email'
    // Note: API scopes are added dynamically from runtime config
    // Directory.Read.All is requested separately for Graph API token
    // The wids claim is included via backend app's optional claims configuration
  ],
};

// Graph API Base URL (static configuration)
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};